import BaseApi from './baseApi';
import IOutboundDetail from '../models/IOutboundDetail';
import IAuthentication from '../models/IAuthentication';
export default class OutboundDetailsApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundDetails(idOutbound: string) : Promise<IOutboundDetail[]> {
        let json : string = this.getJsonRead(idOutbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundDetails: IOutboundDetail[] = [];
            outboundDetails = response.data as IOutboundDetail[];
            return outboundDetails;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundDetail(outboundDetails: IOutboundDetail) : Promise<string> {
        const json = this.getJsonSave(outboundDetails);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundDetail(outboundDetails: IOutboundDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundDetails);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDetailByOutboundId(OutboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundId(OutboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByOutboundId(outboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDetail",
            "conditions": [{
                "Item1": "OutboundsDetail",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": outboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDetail",
            "conditions": [{
                "Item1": "OutboundsDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(outboundDetail: IOutboundDetail): any {
        const round0 = (val: number | null | undefined): number => {
            return typeof val === 'number' ? Math.round(val) : 0;
        };

        const json = {
            "fieldsvalues": [{
                "Item1": "idOutbound",
                "Item2": outboundDetail.idOutbound
            }, {
                "Item1": "idWarehouse",
                "Item2": outboundDetail.idWarehouse
            }, {
                "Item1": "idGood",
                "Item2": outboundDetail.idGood
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": outboundDetail.idInboundDeliveryNoteDetail
            }, {
                "Item1": "totalCases",
                "Item2": outboundDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundDetail.totalGoods
            }, {
                "Item1": "documentation",
                "Item2": outboundDetail.documentation
            }, {
                "Item1": "weight",
                "Item2": outboundDetail.weight
            }, {
                "Item1": "liters",
                "Item2": outboundDetail.liters
            }, {
                "Item1": "totalValue",
                "Item2": outboundDetail.totalValue
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDetail"
        };
        return json;
    }

    private getJsonUpdate(outboundDetail: IOutboundDetail) : any {
        const round0 = (val: number | null | undefined): number => {
            return typeof val === 'number' ? Math.round(val) : 0;
        };
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutbound",
                "Item2": outboundDetail.idOutbound
            }, {
                "Item1": "idGood",
                "Item2": outboundDetail.idGood
            }, {
                "Item1": "idWarehouse",
                "Item2": outboundDetail.idWarehouse
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": outboundDetail.idInboundDeliveryNoteDetail
            }, {
                "Item1": "totalCases",
                "Item2": outboundDetail.totalCases
            }, {
                "Item1": "goodsPerCase",
                "Item2": outboundDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": outboundDetail.totalGoods
            }, {
                "Item1": "documentation",
                "Item2": outboundDetail.documentation
            }, {
                "Item1": "weight",
                "Item2": outboundDetail.weight
            }, {
                "Item1": "liters",
                "Item2": outboundDetail.liters
            }, {
                "Item1": "totalValue",
                "Item2": outboundDetail.totalValue
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDetail",
            "keyvalue": outboundDetail.id
        };
        return json;
    }

    private getJsonRead(idOutbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsDetail",
                "Item2": "id"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "idOutbound"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "Warehouses",
                "Item2": "Name AS warehouseName"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "Name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "Code as goodCode"
            }, {
                "Item1": "",
                "Item2": "(SELECT COUNT(OutboundsDeliveryNotesDetail.id) FROM OutboundsDeliveryNotesDetail WHERE IdOutboundDetail = OutboundsDetail.Id AND Deleted = 0) AS TotalPallets"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "TotalCases"
            }, {
                "Item1": "",
                "Item2": "ISNULL((SELECT SUM(CasesPerPallet) FROM OutboundsNoticeOfLossDetail WHERE IdOutboundDeliveryNoteDetail IN (SELECT Id FROM OutboundsDeliveryNotesDetail WHERE IdOutboundDetail = OutboundsDetail.Id) AND Deleted = 0), 0)  AS CasesLoss"
            }, {
                "Item1": "",
                "Item2": "(SELECT SUM(OutboundsDeliveryNotesDetail.TotalCases) FROM OutboundsDeliveryNotesDetail WHERE IdOutboundDetail = OutboundsDetail.Id AND Deleted = 0) AS InDeliveryNote"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "TotalGoods"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "Documentation"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "IdWarehouse"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "weight"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "liters"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "totalValue"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "",
                "Item2": "(SELECT TOP 1 idListPallet FROM OutboundsDeliveryNotesDetail WHERE IdOutboundDetail = OutboundsDetail.Id AND Deleted = 0) AS idListPallet"
            }, {
                "Item1": "",
                "Item2": "(SELECT TOP 1 LPT.Name FROM OutboundsDeliveryNotesDetail ODD LEFT JOIN ListPalletTypes LPT ON LPT.Id = ODD.idListPallet WHERE ODD.IdOutboundDetail = OutboundsDetail.Id AND ODD.Deleted = 0) AS palletName"
            }, {
                "Item1": "",
                "Item2": "(SELECT TOP 1 SDS.IdPalletCustomer FROM OutboundsDeliveryNotesDetail ODD INNER JOIN SCAN_StockDetailScan SDS ON SDS.IdPallet = ODD.IdPallet WHERE ODD.IdOutboundDetail = OutboundsDetail.Id AND ODD.Deleted = 0) AS IdPalletCustomer"
            }],
            "tables": [{
                "Item1": "OutboundsDetail"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDeliveryNotes"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Warehouses"
            }],
            "joins": [{
                "Item1": "OutboundsDetail",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "idInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "idInboundDeliveryNote",
                "Item3": "InboundsDeliveryNotes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "OutboundsDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsDetail",
                "Item2": "IdOutbound",
                "Item3": "=",
                "Item4": idOutbound,
                "Item5": "AND"
            },
            {
                "Item1": "OutboundsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
